import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

const links = [
  { to: '/temperley', label: 'Sede Temperley' },
  { to: '/glew', label: 'Sede Glew' },
  { to: '/cet', label: 'CET' },
  { to: '/cd', label: 'CD' },
  { to: '/obras-sociales', label: 'Obras Sociales' },
  { to: '/tratamientos', label: 'Tratamientos' },
  { to: '/actividades', label: 'Actividades' },
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <img src="/images/mi_lugar_logo.png" alt="Mi Lugar" width="44" height="44" />
          <span>Mi Lugar</span>
        </Link>

        <ul className={menuOpen ? 'nav-menu active' : 'nav-menu'}>
          {links.map((link) => (
            <li className="nav-item" key={link.to}>
              <Link to={link.to} className="nav-link" onClick={closeMenu}>
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        <Link to="/contacto" className="navbar-cta" onClick={closeMenu}>
          Contactanos
        </Link>

        <button
          type="button"
          className="menu-icon"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={menuOpen}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
